export default class Healthplanpolicies {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/policy/review";
  }

  listClients() {
    return this.client.get(`${this.resourceUrl}/healthplan/client`);
  }
  exportAdoptionHistory(healthPlanKey) {
    return this.client.get(
      `${this.resourceUrl}/healthplan/client/healthplanreviewexport?healthPlanKey=${healthPlanKey}`
    );
  }
}
